import { render, staticRenderFns } from "./EmptyStateFrameless.vue?vue&type=template&id=113db344&scoped=true&"
import script from "./EmptyStateFrameless.vue?vue&type=script&lang=js&"
export * from "./EmptyStateFrameless.vue?vue&type=script&lang=js&"
import style0 from "./EmptyStateFrameless.vue?vue&type=style&index=0&id=113db344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113db344",
  null
  
)

export default component.exports